import React from 'react';
import {Tabs, Tab, withStyles} from '@material-ui/core'
import {withTheme} from "styled-components"

export const AntTabs = withTheme(withStyles({
    root: {
        borderBottom: '1px solid #e8e8e8',
        fontFamily: '"DM Sans", Roboto, helvetica'
    },
    indicator: {
        backgroundColor: ({theme:scTheme}) => scTheme?.colors?.primary || '#212124',
        borderRadius: [2, 2, 0, 0]
    },
})(Tabs));

export const AntTab = withTheme(withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        maxWidth: 240,
        height: 60,
        [theme.breakpoints.up('sm')]: {
            maxWidth: 360,
            height: "auto",
        },
        fontWeight: theme.typography.fontWeightRegular,
        // marginRight: theme.spacing(4),
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
            color: ({theme:scTheme}) => scTheme?.colors?.neutral || '#212124',
            opacity: 1,
        },
        '&$selected': {
            color: ({theme:scTheme}) => scTheme?.colors?.neutral || '#212124',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
            color: ({theme:scTheme}) => scTheme?.colors?.neutral || '#212124',
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />));